import axios from 'axios';
import { marcaBlancaApi } from './endpoints';

const client = axios.create({
  baseURL: process.env.RAZZLE_API_MARCA_BLANCA,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const getBanner = async (bannerId, token) => {
  client.defaults.headers.Authorization = `Bearer ${token}`;
  return (await client.get(marcaBlancaApi.getBannerById(bannerId)))?.data;
};
